var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.847,
    height: 25.611,
    viewBox: "0 0 13.847 25.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_30593",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 30593",
    d: "M35.4.005,32.081,0c-3.731,0-6.142,2.474-6.142,6.3V9.209H22.6a.522.522,0,0,0-.522.522v4.211a.522.522,0,0,0,.522.522h3.339V25.088a.522.522,0,0,0,.522.522h4.357a.522.522,0,0,0,.522-.522V14.464h3.9a.522.522,0,0,0,.522-.522l0-4.211a.523.523,0,0,0-.522-.522H31.34V6.745c0-1.184.282-1.785,1.825-1.785H35.4a.522.522,0,0,0,.522-.522V.528A.522.522,0,0,0,35.4.005Z",
    transform: "translate(-22.077 0)",
    fill: "#1722b8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d21d18ee32de1574ede35cb43f1c44bb.svg";
export { ForwardRef as ReactComponent };